import { styled } from '@mui/system';
import AddBoxIcon from '@mui/icons-material/AddBox';
import AddHomeIcon from '@mui/icons-material/AddHome';
import MapRoundedIcon from '@mui/icons-material/MapRounded';
import CameraIcon from '@mui/icons-material/Camera';
import BookmarksIcon from '@mui/icons-material/Bookmarks';
// import Notification from '../.././../Notification';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../../../store/auth/authSlice';
import { useGetUserProfileQuery } from '../../../../../store/api/userApi';
import Loading from '../../../../../components/ui/Loading';

const LinkItemsGroup = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginRight: '30px',
  gap: '15px',
  [theme.breakpoints.down('sm')]: {
    position: 'fixed',
    zIndex: '2',
    top: '40px',
    height: '40px',
    backgroundColor: 'rgba(217, 217, 217)',
    justifyContent: 'space-evenly',
    width: '100vw',
    margin: '0',
    boxShadow: '0px 2px 2px rgb(0 0 0 / 25%)',
    backdropFilter: 'blur(7.5px)',
  },
}));

const LinkItem = styled('a')(({ theme }) => ({
  height: '20px',
  '& svg': {
    fontSize: 23,
    color: '#fff',

    [theme.breakpoints.down('sm')]: {
      color: 'rgba(0, 0, 0, 0.54)',
    },
  },
}));

const NotificationContainer = styled('div')(({ theme }) => ({
  '& a': {
    height: '20px',
  },
  '& svg': {
    color: '#fff',
    [theme.breakpoints.down('sm')]: {
      color: 'rgba(0, 0, 0, 0.54)',
    },
    '& path': {
      fill: 'currentColor',
      stroke: 'currentColor',
    },
  },
}));

const LinkItems = () => {
  const author = useSelector(selectUser);

  let role = localStorage.getItem('role');

  if (role === 'undefined') {
    role = 1;
  }

  return (
    <LinkItemsGroup>
      <LinkItem href="/">
        <MapRoundedIcon />
      </LinkItem>
      <LinkItem href="/note/create">
        <AddBoxIcon />
      </LinkItem>
      {Number(role) === 0 ? (
        <LinkItem href="/cafe/create">
          <AddHomeIcon />
        </LinkItem>
      ) : null}
      <LinkItem href="/feed">
        <CameraIcon />
      </LinkItem>
      <LinkItem href="/">
        <BookmarksIcon />
      </LinkItem>
      {/* <NotificationContainer>
        <Notification />
      </NotificationContainer> */}
    </LinkItemsGroup>
  );
};

export default LinkItems;
